<template>
  <div class="help-container">
    <template v-if="help">
      <HelpItem
        v-for="node in help.nodes"
        :key="node.id"
        :help="node" />
    </template>
    <div
      class="no-content-container"
      v-else>
      <h3 class="no-content-available">
        {{ $t('components.help.noContentAvailable', 'Sorry this Content isn\'t available right now') }}
      </h3>
      <ShowTraining />
    </div>
  </div>
</template>

<script>
import HelpItem from './HelpItem'
import ShowTraining from '../Training/ShowTraining'
import { mapActions } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  asyncComputed: {
    help: {
      lazy: true,
      default () {
        return {
          nodes: []
        }
      },
      get () {
        return this.loadFromItem(this.item)
      }
    }
  },
  methods: {
    ...mapActions('help', [
      'loadFromItem'
    ])
  },
  components: {
    HelpItem,
    ShowTraining
  }
}
</script>

<style lang="scss" scoped>
    @import "~common-assets/scss/we";

    .help-container {
      overflow: hidden;
      .no-content-container {
        text-align: center;
        .no-content-available {
          margin: 20px;
        }
      }
    }
</style>
